import React from "react";
import SkeletonLoader from "./SkeletonLoader";
import Pagination from "./CustomPagination";
import UsersListTable from "./UsersListTable";
import TeamUsersFilterToolbar from "./TeamUsersFilterToolbar";

export function getTeamUsersEmptyDescription({
  hasFilterChanges,
  searchTerm,
  defaultDescription = "Your organization doesn't have any team members yet.",
  filteredDescription = "No team members match the current filters and search.",
}) {
  return hasFilterChanges || searchTerm ? filteredDescription : defaultDescription;
}

/**
 * Manage Account → Team tab panel (filters + Add CTA + table + pagination).
 */
export default function OrgTeamMembersPanel({
  filterDefinitions,
  filters,
  onFilterChange,
  onClearFilters,
  showClearFilters,
  onAddTeamMember,
  addButtonLabel = "Add Team Member",
  isLoading = false,
  columns,
  data = [],
  actionMenuItems,
  sortConfig,
  onSort,
  rowKey,
  emptyMessage = "No team members found",
  emptyDescription,
  isSearchActive = false,
  getRowClassName,
  onRowClick,
  currentPage = 1,
  onPageChange,
  totalPages = 1,
}) {
  return (
    <div className="w-full bg-white shadow-sm rounded-lg">
      <TeamUsersFilterToolbar
        className="px-4 pt-6 pb-3 sm:px-6 lg:px-8"
        filters={filterDefinitions}
        values={filters}
        onChange={onFilterChange}
        onClear={onClearFilters}
        showClearFilters={showClearFilters}
        actions={
          <button
            type="button"
            className="inline-flex items-center rounded-md bg-indigo-600 px-3 py-2 text-sm font-medium text-white hover:bg-indigo-500 focus:outline-none"
            onClick={onAddTeamMember}
          >
            {addButtonLabel}
          </button>
        }
      />
      {isLoading ? (
        <SkeletonLoader />
      ) : (
        <>
          <div className="w-full">
            <UsersListTable
              columns={columns}
              data={data}
              actionMenuItems={actionMenuItems}
              sortConfig={sortConfig}
              onSort={onSort}
              rowKey={rowKey}
              emptyMessage={emptyMessage}
              emptyDescription={emptyDescription}
              className="shadow-sm"
              isSearchActive={isSearchActive}
              getRowClassName={getRowClassName}
              onRowClick={onRowClick}
            />
          </div>
          {data.length > 0 && (
            <div className="border-t border-gray-200">
              <Pagination
                currentPage={currentPage}
                onPageChange={onPageChange}
                totalPages={totalPages}
              />
            </div>
          )}
        </>
      )}
    </div>
  );
}
